module.exports = {
	METALLIC_CARD_TYPE: '506',
	METALLIC_STANDARD: '0000001',
	METALLIC_SUBTYPE_DE: '020',
	METALLIC_SUBTYPE_NL: '021',
	METALLIC_SUBTYPE_PT: '022',
	MAESTRO_TYPE: '506',
	MAESTRO_STANDARD: '0000020',
	MAESTRO_SUBTYPE: '002',
	MAESTRO_PROCESS_SUBTYPE: '019'
}